export const navStyles = {
  boxShadow: '0px 1px 10px rgba(0, 0, 0, .05)',
  width: '100vw',
  zIndex: 1,
};
